import { ResourceKey } from '../types/common.js';
/*
 * Display metadata only. This used to carry a `baseProduction` and
 * `growthFactor` per resource, which nothing read: the real curves live on the
 * producing building in buildings.ts, and these had drifted years out of date
 * (wood at 30 and 1.16 against the 100 and 1.1195 actually shipped). A second
 * set of balance numbers that nothing consumes is worse than none.
 */
export const RESOURCE_META = {
    wood: {
        key: ResourceKey.WOOD,
        displayName: 'Timber',
        shortName: 'Wood',
        icon: '🪵',
        description: 'Felled and seasoned in the timber camps. The bones of every building.',
    },
    clay: {
        key: ResourceKey.CLAY,
        displayName: 'Clay',
        shortName: 'Clay',
        icon: '🧱',
        description: 'Dug from the riverbanks and fired into brick for walls and kilns.',
    },
    iron: {
        key: ResourceKey.IRON,
        displayName: 'Iron',
        shortName: 'Iron',
        icon: '⛏️',
        description: 'Hauled out of the deep seams. Weapons, armour, and tools.',
    },
    grain: {
        key: ResourceKey.GRAIN,
        displayName: 'Grain',
        shortName: 'Grain',
        icon: '🌾',
        description: 'Feeds the village and every soldier in it. Run out and the queues stop.',
    },
};
/**
 * Barter rates used by the market, expressed in "wood-equivalents" per unit.
 * Derived from the GDD exchange table:
 *   wood:clay 1:1, wood:iron 1.5:1, clay:iron 1.2:1, grain:resources 2:1
 * Iron is the mean of the two stated iron rates (1.5 and 1.2) to keep the
 * table internally consistent - a single value cannot satisfy both exactly.
 */
export const RESOURCE_BARTER_VALUE = {
    wood: 1.0,
    clay: 1.0,
    iron: 1.35,
    /*
     * Grain was 2.0, worth twice a log, from a table written when a farm made
     * less of it than a timber camp made wood. A farm now out-produces a pit by
     * half again, so at 2.0 a lord could pour grain into the market and draw out
     * iron at better than one for one for ever. A resource is worth what it is
     * scarce by: grain is the most plentiful thing a village makes and the only
     * one it cannot bank, so it trades at a little over half a log.
     */
    grain: 0.6,
};
/** How many units of `to` you receive for one unit of `from`. */
export function exchangeRate(from, to) {
    return RESOURCE_BARTER_VALUE[from] / RESOURCE_BARTER_VALUE[to];
}
//# sourceMappingURL=resources.js.map